import Vue from 'vue';
import Vuex from 'vuex';

import { axiosClient } from '../api';

import { auth } from './modules/auth';
import { admin } from './modules/admin';
import { customer } from './modules/customer';

Vue.use(Vuex);

const state = {
  navigationHistory: {},
  isNavOpen: false,
  languages: [],
  language: {},
};

const getters = {};

const actions = {
  async getLanguages({ commit }) {
    try {
      const res = await axiosClient.get('/languages');
      commit('setLanguages', res.data.data);
      return res.data.data;
    } catch (error) {
      console.error({ ...error });
    }
  },
};

const mutations = {
  openMobileNav(state) {
    state.isNavOpen = true;
  },
  closeMobileNav(state) {
    state.isNavOpen = false;
  },
  setLanguages(state, languages) {
    state.languages = languages;
  },
  setLanguage(state, language) {
    state.language = language;
  },
};

const modules = { auth, admin, customer };

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  modules,
});
